<template>
    <div class="main">
        <v-card flat>
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <b>
                        Print Receipt
                    </b>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-btn v-if="learner_receipt_data != null" class="ma-2 no-display" id="wv_btn" tile outlined color="warning"
                @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
            <div id="document1" class="printdiv">
                <v-simple-table dense class=" table-container" style="border: 1px solid black;">
                    <template v-slot:default>
                        <thead>
                            <tr v-bind="org_basic_data != ''">
                                <td colspan="3" v-if="org_basic_data.trust_logo">
                                    <v-row dense justify="center">
                                        <v-col cols="12" md="3" sm="3" class="pr-0">
                                            <center><img class="school-logo" :src="org_basic_data.trust_logo"
                                                    width="150" height="150" alt="logo" /></center>
                                        </v-col>
                                        <v-col cols="12" md="9" sm="9" style="align-content: center;" class="pl-0 line-height">
                                            <center>
                                                <div style="font-size: x-large; font-family: serif; text-transform: uppercase;"
                                                    class="school-name" v-if="org_basic_data.school_name">
                                                    <b>{{ org_basic_data.school_name }} </b>
                                                </div>
                                                <div v-if="org_basic_data.address">
                                                    {{ org_basic_data.address }}
                                                </div>
                                            </center>
                                        </v-col>
                                    </v-row>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-left line-height" colspan="3">
                                    <div style="display: flex; justify-content: space-between;">
                                        <span><b>Receipt No.: {{ learner_receipt_data.receipt_no }}</b></span>
                                        <span><b>Academic Year : {{ learner_receipt_data.ay }}</b></span>
                                    </div>

                                    <div style="display: flex; justify-content: space-between;">
                                        <span><b>Full Name of Student : {{ learner_receipt_data.name }}</b></span>
                                        <span><b>Date : {{ learner_receipt_data.receipt_date }}</b></span>
                                    </div>

                                    <div class="text-left"><b>Name of the Parent : {{ learner_receipt_data.father_full_name }}</b></div>

                                    <div class="text-left">
                                        <b>Class : {{ learner_receipt_data.standard }}
                                            <span v-if="learner_receipt_data.section != 'Pre-primary'">
                                                ({{ learner_receipt_data.quota }})
                                            </span>
                                        </b>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style="width: 10%"><b>Sr. No.</b></td>
                                <td class="text-left"><b>Fee Type</b></td>
                                <td style="width: 25%"><b> Fee Amount (Rs.)</b></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in learner_receipt_data.student_receipt_details" :key="item.id">
                                <td>
                                    {{ item.srno }}
                                </td>
                                <td class="text-left">
                                    {{ item.component }}
                                </td>
                                <td>{{ item.amount }}.00</td>
                            </tr>
                            <tr>
                                <td class="text-center" colspan="2"><b>Total Amount</b></td>
                                <td>{{ learner_receipt_data.total_fees_amount }}.00</td>
                            </tr>
                            <tr class="text-center">
                                <td colspan="3" style="height: 35px; font-size: 15px" class="row-height">
                                    <b> Amount In Words :</b>
                                    {{ learner_receipt_data.amount_in_words }}
                                </td>
                            </tr>
                        </tbody>
                        <tr class="end-row">
                            <td colspan="3" class="line-height">
                                <div class="text-left">
                                    <b> Payment Mode : </b>
                                    {{ learner_receipt_data.payment_mode }}
                                </div>
                                <div v-if="learner_receipt_data.payment_mode != 'Cash' && learner_receipt_data.bank_name"
                                    class="text-left">
                                    <b> Bank :</b>
                                    {{ learner_receipt_data.bank_name }}
                                </div>
                                <div class="text-left"
                                    v-if="learner_receipt_data.payment_mode != 'Cash' && learner_receipt_data.branch_name">
                                    <b> Branch :</b>
                                    {{ learner_receipt_data.branch_name }}
                                </div>
                                <div class="text-left" v-if="learner_receipt_data.payment_mode != 'Online'">
                                    <b> Payment Details:</b>
                                    {{ learner_receipt_data.remark }}
                                </div>
                                <div v-if="learner_receipt_data.payment_mode != 'Cash'" class="text-left">
                                    <b> DD / Cheque / Transaction No.:</b>
                                    {{ learner_receipt_data.trnx_id }}
                                </div>
                                <div v-if="learner_receipt_data.payment_mode != 'Cash'" class="text-left">
                                    <b> DD / Cheque / Transaction Date:</b>
                                    {{ learner_receipt_data.transaction_date }}
                                </div>
                                <div v-if="learner_receipt_data.remark" class="text-left">
                                    <b> Remark :</b>
                                    {{ learner_receipt_data.remark }}
                                </div>
                                <v-row>
                                    <v-col cols="12" sm="5" md="5"> </v-col>
                                    <v-col cols="12" sm="7" md="7">
                                        <span style="position: absolute; right: 20px;"> <b>For</b> <b
                                                style="font-family: Times new roman;text-transform: uppercase;">
                                                {{ org_basic_data.school_name }} </b></span>
                                    </v-col>
                                </v-row>
                                <br />
                                <br />
                                <span style="position: absolute; right: 100px;"><b>Signature</b></span>
                                <br />
                                <div class="text-left">
                                    <br>
                                    <b>Note: This is an electronically generated receipt, hence does not require a
                                        signature.</b>
                                </div>
                            </td>
                        </tr>
                    </template>
                </v-simple-table>
            </div>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data() {
        return {
            overlay: false,
            learner_receipt_data: null,
            radios: null,
            receipt_no: null,
            registration_no: null,
            ay: null,
            org_basic_data: [],
        };
    },
    watch: {
        receipt_no() {
            this.getData();
        },

        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },
    created() {
        this.receipt_no = JSON.parse(this.$session.get("receipt_no"));
        this.ay = JSON.parse(this.$session.get("ay"));
        this.registration_no = JSON.parse(this.$session.get("registration_no"));
    },
    mounted() {
        this.getData();
    },
    methods: {
        print() {
            var content = document.getElementById("document1").innerHTML;
            var mywindow = document.body.innerHTML;
            document.body.innerHTML = content;
            window.print();
            document.body.innerHTML = mywindow;
            location.reload();
            return true;
        },
        convert(number) {
            var converter = require("number-to-words");
            const string = converter.toWords(number);
            const string1 = string.charAt(0).toUpperCase() + string.slice(1);
            return string1;
        },
        getData() {
            this.overlay = true;
            this.learner_receipt_data = null;
            const formData = {
                receipt_no: this.receipt_no,
                registration_no: this.registration_no,
                ay: this.ay,
            };
            axios
                .post("/AccountingAndFeesReports/getFeeReceipts", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.learner_receipt_data = res.data.student_receipt_details;
                        this.org_basic_data = res.data.org_basic_data;
                        this.overlay = false;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                        this.overlay = false;
                        return;
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
    },
};
</script>
<style scoped>
.text-left {
    text-align: left;
}

tr,
td,
th {
    border: 1px solid black !important;
    text-align: center;
    font-size: small;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    table,
    td,
    tr {
        break-inside: avoid-page;
    }

    img {
        width: 120% !important;
    }

    .line-height {
        line-height: 150% !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    @page {
        size: 16in 22in;
    }

    .school-logo {
        width: 350px !important;
        height: 350px !important;
    }

    .row-height {
        height: 100px !important;
    }

    .text-left {
        text-align: left;
    }

    .end-row {
        border: none !important;
    }

    .school-name {
        font-size: 50px !important;
        margin-bottom: 10px !important;
    }

    table,
    tr,
    td,
    th {
        text-align: center !important;
        margin-top: none;
        padding: 1.2rem !important;
        font-size: xx-large !important;
        border: 1px solid black !important;
    }
}

.table-container {
    overflow-x: hidden;
    overflow: hidden;
}
</style>